// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-belmont -> aion-management-belmont -> fox-ridge-and-lakeview-park-apartments
// Generated: 2026-10-22T20:07:03.358Z
// Counts: 1 design, 69 content, 66 slot group, 1 collection binding, 9 section, 10 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.pretitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 & 2 BEDROOM LAYOUTS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 & 2 Bedroom Apartments for Rent in Limerick & Royersford , PA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Fox Ridge & Lakeview Park Apartments</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Fox Ridge & Lakeview Park Apartments in Limerick & Royersford, PA, where your dream home meets vibrant community living! Nestled near parks, schools, and the Greater Philadelphia Expo Center, enjoy convenient access to entertainment and education. Embrace a lifestyle enriched by nearby attractions and top-notch amenities. Your perfect home awaits—come see for yourself!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>tour anytime. from anywhere.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>your new home awaits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace Life in Your Perfect Apartment Home Today</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility Statement</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get more out of your time every time with the convenience we offer at Fox Ridge &amp; Lakeview Park Apartments in Limerick &amp; Royersford, Pennsylvania. Days are made more efficient with resident perks like an <a href=\"https://www.liveatfoxridge.com/gallery/\">on-site fitness center</a>, giving you more time to enjoy a relaxing break on your private balcony or patio or warm up by the fireplace. Browse below to see all the features you get when you make Fox Ridge &amp; Lakeview Park Apartments your home. Then, when you’re ready, <a href=\"https://www.liveatfoxridge.com/contact-us/\">reach out to our friendly leasing team.&nbsp;</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Interior</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover ideal apartments with patio or balcony in Fullerton, PA. Enjoy serene outdoor spaces with modern amenities at Fairmont Place.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with Patios &amp; Balconies in Fullerton, PA</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the community layout</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet-friendly living guidelines</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Resident Portal</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Download the Loft Resident Mobile App</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "elise-schedule-tour-iframe",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitemap</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into comfort at Fox Ridge & Lakeview Park Apartments in Limerick & Royersford, PA. Choose from spacious one and two-bedroom floor plans and enjoy a host of amenities, from a fitness center to serene pond views. With pet-friendly options and flexible leasing, your ideal living space awaits. Lease online today and elevate your lifestyle!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Fox Ridge &amp; Lakeview Park Apartments in Limerick &amp; Royersford, PA, our <a href=\"https://www.liveatfoxridge.com/floor-plans/\">thoughtfully designed one and two-bedroom floor plans</a> cater to your lifestyle. Each space is crafted for comfort and convenience, making it the perfect home. Have questions? Reach out to our leasing team today to learn more about your future residence!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Every floor plan at Fox Ridge &amp; Lakeview Park Apartments features an intuitive design for ease and comfort. A blend of wood-style plank flooring and ceramic tile flooring adds character, accentuated by lofty, high ceilings. Just like you’d expect from proper suburban living, we've included spacious additions like large closets, a breakfast nook, and a private balcony or patio. Please peruse our <a href=\"https://www.liveatfoxridge.com/virtual-tour/\">one and two bedroom layouts</a> to find the one that calls to you, then reach out to our friendly leasing team to see it in person.&nbsp;</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.leasing_office_label": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Leasing Office Located At:</strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Fox Ridge &amp; Lakeview Park Apartments in Limerick &amp; Royersford, PA, vibrant living meets modern comfort. Whether you prefer a cozy <a href=\"https://www.liveatfoxridge.com/floor-plans/\">one-bedroom or a spacious two-bedroom</a>, our upgraded spaces with stunning pond views, stainless steel appliances, and inviting amenities like a fitness center and tennis court make every day exceptional. <a href=\"https://www.liveatfoxridge.com/virtual-tour/\">Picture yourself living here</a>!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Quaint suburban locale and daily convenience converge at your new spot in the Limerick and Royersford neighborhoods. <a href=\"https://www.liveatfoxridge.com/schedule-a-tour/\">If you’re looking for a place to escape</a> the city noise but still want the advantages of a well-connected area, Fox Ridge &amp; Lakeview Park Apartments is your obvious choice. The Limerick and Royersford area gives you room to breathe and a bounty of opportunities. Explore our map below to see some of the local highlights.&nbsp;</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Stylish Apartment Living in Limerick & Royersford , PA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>We’re a pet‑friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. There is a one‑time, non‑refundable pet fee of $350, and monthly pet rent is $50.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>You’re invited to the peaceful yet <a href=\"https://www.liveatfoxridge.com/neighborhood/\">connected suburban lifestyle</a> you’ve imagined at Fox Ridge &amp; Lakeview Park Apartments. This is the place that makes home feel like it should, giving you stylish, cozy interiors, a garden-style community filled with welcoming spaces, and <a href=\"https://www.liveatfoxridge.com/amenities/\">an assortment of thoughtful perks</a> to streamline your routines. You’ll love your charming, new neighborhood, where you’ll have daily convenience and local favorites close by. Keep exploring to discover why Fox Ridge &amp; Lakeview Park Apartments is your preferred living destination in Limerick and Royersford, Pennsylvania.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Fox Ridge & Lakeview Park Apartments in Limerick & Royersford, PA, tailored living awaits with spacious one and two-bedroom floor plans. Join our vibrant community today and elevate your lifestyle. Access your resident portal effortlessly to pay rent, schedule maintenance, and enjoy seamless living. Your comfortable home journey starts here!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Fox Ridge & Lakeview Park Apartments in Limerick & Royersford, PA, we offer thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Experience the perfect blend of comfort and convenience. Schedule a tour today and see what our residents love most about calling Fox Ridge & Lakeview Park Apartments home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out to Fox Ridge & Lakeview Park Apartments in Limerick & Royersford, PA! We’re excited to assist you in finding your perfect home. With captivating one and two-bedroom floor plans, we offer a variety of options to suit your lifestyle. Stay tuned—our team will be in touch shortly!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>See more of what’s in store for you at Fox Ridge &amp; Lakeview Park Apartments with a virtual tour. <a href=\"https://www.liveatfoxridge.com/gallery/\">It’s the next best thing to actually being here.</a></p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contact-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Floor Plans"
      }
    }
  },
  "pinnedcallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Availability & Pricing"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-97ed-72c9-a81e-1bb33ab140bf.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright modern white kitchen with stainless steel appliances and wood flooring"
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-ce68-7619-8041-881837fef73e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright blue gym with treadmills, elliptical, and strength machines in a modern workout room"
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-ce68-7619-8041-881837fef73e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright blue gym with treadmills, elliptical, and strength machines in a modern workout room"
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-d313-77bf-9cb8-afb5714abd26.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright blue gym with treadmills, dumbbells, and workout bench under a vaulted ceiling"
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166316/019d0268-06a8-70f4-af83-545208c26b78.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with cardio machines and weight training equipment."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-8e4d-71db-835f-1326feb1a6bb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern white kitchen with stainless steel refrigerator, oven, microwave, and cabinetry. Visit us at Fox Ridge & Lakeview Park Apartments and view our apartments for rent in Limerick, PA."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-9911-7514-bd5c-50c1fc65d0b3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright modern living room with white walls, gray sofa, fireplace, and round window overlooking a dining area"
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-8e62-71b8-99e3-1390d5363613.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment bedroom with a large bed, two nightstands, and an open closet. Visit us at Fox Ridge & Lakeview Park Apartments and view our modern, garden-style 1 and 2 bedroom apartments in Limerick, PA."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-faf3-703a-a159-7b288eae7ae1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a brick and beige siding apartment building with lawns and sidewalks. Visit us at Fox Ridge Apartments and view our modern, garden-style 1 and 2 bedroom apartments in Limerick and Royersford, PA."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-9ca9-755f-93f8-10edc1e09567.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Limerick Community Park near Fox Ridge Apartments, with a playground, picnic pavilions, and sports courts in Limerick, PA."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-865b-75b9-8b32-4d947de815d4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The King of Prussia mall, a skylit indoor shopping destination with 400+ retailers, near Fox Ridge Apartments in Limerick, PA."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-a58e-73ac-82b5-38cbbd307c78.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Royersford Riverfront Park along the Schuylkill River, with a scenic walking path and picnic tables, near Fox Ridge Apartments."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-e998-72ca-a403-dbdcd648c048.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Covered picnic area with grills and picnic tables."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-e08a-739f-bf8c-20a29bcd65de.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Chain-link fence enclosing a grassy dog park with trees under a blue sky with clouds"
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-e998-72ca-a403-dbdcd648c048.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Covered picnic area with grills and picnic tables."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-f80d-7758-b63f-eb8704cab7b0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Wooden gazebo in a landscaped garden area of a residential community. Visit us at Fox Ridge & Lakeview Park Apartments and view our modern, garden-style 1 and 2 bedroom apartments in Limerick, PA."
      }
    }
  },
  "feesheet.admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": ""
      },
      "amount": {
        "type": "VALUE",
        "customValue": "",
        "mappedField": "property_admin_fee"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.custom_situational": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Admin Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "350"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Assessed per occurrence for any modification to the Lease Agreement, including but not limited to the addition, removal, or substitution of any leaseholder or occupant."
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.lockout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Lockout Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.parking_reserved": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Parking - Reserved/Covered"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.pet_fee_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_rent_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "25"
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Trash Service"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility Admin / Billing"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$4.66"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fce69-66c4-721d-ba70-73c6bbb2f3f7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment home office with wooden desk, metal shelving, and an open door to a hallway. Visit us at Fox Ridge Apartments and view our pet-friendly apartments for rent in Limerick, PA."
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0267-c990-76cf-9d43-6b609dcc2dcb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "White apartment kitchen with cabinets, stove, microwave, and refrigerator."
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fce69-66fe-7207-b060-09544d9bf519.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a large bed, neutral gray walls, and an open closet near the bathroom. Visit us at Fox Ridge Apartments and view our modern, garden-style 1 and 2 bedroom apartments in Limerick, PA."
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fce69-66c8-7343-857f-d207f958dcfd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open-concept kitchen and living area in a modern apartment. Visit us at Fox Ridge Apartments and view our apartments for rent in Limerick, PA."
      }
    }
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-d8ef-75e9-94be-e8063d3b9498.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious modern apartment living room with gray sectional, two chairs, fireplace, and sliding glass door."
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo_media.alt_text"
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-645e-7514-bcef-e1e2d987c2e8.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Java's Brewin'"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Coffee & Cafe"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Coffee and tea shop serving homemade muffins as well as breakfast sandwiches and coffee smoothies."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-865b-75b9-8b32-4d947de815d4.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "King of Prussia"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "12 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Sprawling & elegant, skylit indoor mall with 400+ retailers, plus food courts & restaurants."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-9ca9-755f-93f8-10edc1e09567.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Limerick Community Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Recreation"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Public park with a playground, picnic pavilions, basketball and volleyball courts, and a baseball field."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-4fb0-748e-990b-4e1e00395c24.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Copperfield Inn at Lakeside"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Brunch & Dining"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.1 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Elegant, romantic American restaurant with some Italian dishes, banquet facilities & Sunday brunch."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-7c23-7168-9381-164609eabf61.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "American Treasure Tour Museum"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "9 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Unique place displaying eclectic Americana, including antiques, kitsch & pop culture items."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-b43b-7748-8b8a-ccb1c414c3ea.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Schuylkill River Trail - Parkerford Parking & Trailhead"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Trails & Recreation"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Riverside trailhead and parking along the scenic Schuylkill River Trail, ideal for walking, running, and biking."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-636c-71ec-aae9-526f2518bc49.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Lost Planet Brewing Company"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Brewery & Bar"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Local craft brewery pouring house-made beers in a laid-back, welcoming taproom setting."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-5cd7-74ea-83fc-0d1bbd46c3a3.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Brewed Awakening"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Live Music"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Cozy hangout offering breakfast sandwiches, coffees, and desserts, plus live music."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-5731-7412-a7ce-1c4fd94e267f.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Downtown Gastropub & Restaurant"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Dinner & Drinks"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Comfort food and a variety of brews offered in a casual space with live music."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-839d-764a-8c42-ca8f27034301.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Valley Forge Casino Resort"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Lounge & Nightlife"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.1 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Casual casino hotel offering a spa, a seasonal outdoor pool & dining, plus 2 event venues."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-7d9b-7212-8933-8572edba3a71.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Regal Oaks"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cinema"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "8 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Theater complex with multiple screens featuring new release films, plush seating & concession stand."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-5d6c-75d9-bb2b-9a981691ea31.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Handel's Homemade Ice Cream"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Dessert & Late-Night"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Long-standing ice cream parlor offering many flavors of ice cream & sorbet, plus sundaes & shakes."
      }
    }
  },
  "neighborhoodshowcase.photo1": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo2": {
    "sourceIndex": 27,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo3": {
    "sourceIndex": 32,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo4": {
    "sourceIndex": 31,
    "fieldOverrides": null
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.images": {
    "limit": 3,
    "hiddenIds": null,
    "orderedIds": [
      "custom_f6a9d27f-e329-4187-afd9-a8b15bc84035",
      "custom_027d76d1-a5bc-4fb9-8e63-4e0eb8d719f5",
      "custom_4e1fccd0-cb4b-4482-868d-9ba47e638e0e",
      "custom_5665a5f3-b3ae-4ad3-9e05-4b3015c69f11",
      "custom_7553f4c5-a991-4715-96ec-292c120d1346",
      "custom_bb2e9eec-634f-42c8-b7de-2b2d55912921",
      "custom_ccb6a96f-3bc7-4204-8a19-9c95ffc73805",
      "custom_253d1117-39d8-491a-87f8-443ef27815eb",
      "custom_654cc064-d907-447c-8708-a6863e4d9ba7",
      "custom_e451cc99-7bf3-40b4-9740-aaa8ef423fc9",
      "custom_08b52763-a9af-42ea-a4a0-7ba2aa40b4e1",
      "custom_7e4eab75-d48a-49c2-a77c-ce47de58c7a3",
      "custom_9a8dd0ab-18da-46fb-9f90-8ff9bd447f36",
      "custom_a30be315-9745-4be3-b4d6-6fca09591d54",
      "custom_b258984a-b8b4-42bb-b91c-185a11aacdde",
      "custom_66f48979-45e1-4b70-8f39-36f60d3e61fc",
      "custom_64116a98-8328-4753-a56c-caae32936ae0",
      "custom_35915b0f-a349-4de8-8011-81cfa881fbde",
      "custom_2a1ad627-63c2-4e8e-a18f-7d2dd67abaac",
      "custom_a1958ad1-2502-4389-9305-bd4044fe9f03",
      "custom_f443a2fd-a957-4a8d-a06b-f2658cde6a2f"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_template:hyperlocal::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/air-conditioned-apartments-newport-news-city-harborstone-444::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/dog-park-apartments-newport-news-va-harborstone-222::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/extra-storage-apartments-fullerton-pa-469::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/fitness-center-apartments-23601-harborstone-366::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/pet-friendly-apartments-south-newport-news-harborstone-651::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px"
    }
  },
  "footer.address_2": {
    "properties": {
      "paddingTop": "10px"
    }
  }
};
